import navigation from './navigation.json';
import footer from './footer.json';
import auth from './auth.json';
import home from './home.json';
import quest from './quest.json';
import saint from './saint.json';
import saintOfDay from './saint-of-day.json';
import common from './common.json';
import quiz from './quiz.json';
import about from './about.json';
import subscription from './subscription.json';
import demo from './demo.json';
import dashboard from './dashboard.json';
import lesson from './lesson.json';
import terms from './terms.json';
import privacy from './privacy.json';
import blog from './blog.json';
import donate from './donate.json';
import liturgicalObjects from './liturgical-objects.json';
import guessTheSaint from './guess-the-saint.json';
import dailyTrivia from './dailyTrivia.json';
import sacramentalsMemory from './sacramentals-memory.json';
import sequenceBuilder from './sequence-builder.json';
import emojiQuiz from './emoji-quiz.json';
import virtueVice from './virtue-vice.json';
import rosaryArt from './rosary-art.json';
import pilgrimsArcade from './pilgrims-arcade.json';
import spotTheHeresy from './spot-the-heresy.json';
import geographyQuest from './geography-quest.json';
import bibleTimeline from './bible-timeline.json';
import catholicDecoder from './catholic-decoder.json';
import bibleStudy from './bible-study.json';
import prayers from './prayers.json';
import games from './games.json';
import mappaCaeli from './mappa-caeli.json';
import mappaCaeliLearning from './mappa-caeli-learning.json';

export default {
  ...navigation,
  ...footer,
  ...auth,
  ...home,
  ...quest,
  ...saint,
  ...common,
  ...quiz,
  ...about,
  ...subscription,
  ...demo,
  ...dashboard,
  ...lesson,
  terms,
  privacy,
  blog,
  ...saintOfDay,
  ...donate,
  ...liturgicalObjects,
  ...guessTheSaint,
  ...dailyTrivia,
  sacramentalsMemory,
  ...sequenceBuilder,
  ...emojiQuiz,
  ...virtueVice,
  ...rosaryArt,
  ...pilgrimsArcade,
  ...spotTheHeresy,
  ...geographyQuest,
  ...bibleTimeline,
  ...catholicDecoder,
  ...bibleStudy,
  ...prayers,
  ...games,
  ...mappaCaeli,
  ...mappaCaeliLearning
};